import React, { Fragment, useEffect } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom'
import Home from './pages/Home';
import Product from './pages/Product';
import Case from './pages/Case'
import About from './pages/About'
import DownLoad from './pages/DownLoad'
import Grade from './pages/Grade'
import Report from './pages/Report'
function RouteComponent() {
  useEffect(() => {
    window.scrollTo(0, 0)
  })
  return (
    <Fragment>
      <Switch>
        <Route exact path="/home" component={Home}></Route>
        <Route path="/product" component={Product}></Route>
        <Route path="/home" component={Home}></Route>
        <Route path="/downLoad" component={DownLoad}></Route>
        <Route path="/case" exact component={Case}></Route>
        <Route path="/about" exact component={About}></Route>
        <Route path="/grade" exact component={Grade}></Route>
        <Route path="/report" exact component={Report}></Route>
        <Redirect to="/home"></Redirect>
      </Switch>
    </Fragment>
  );
}
export default RouteComponent;
